import React from 'react';
import LookupItemService from '../../../../../Services/LookupItemService';
import LoadingIcon from '../../../../LoadingIcon';
import MultiChoice from './MultiChoice';
import ErrorMessage from '../../../../ErrorMessage';

export default class LookupMultiChoice extends React.Component {
  static defaultProps = {
    lookupId: 6,
    label: '',
    onChange: () => alert('LookupMultiChoice Onchange'),
    selected: [],
    fieldName: '',
    textAsValue: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      itemList: [],
      selected: null,
    };
    this.multiSelectOnChange = this.multiSelectOnChange.bind(this);
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.populateListData();
    }
  }

  populateListData() {
    LookupItemService.GetLookupItemListByLookupId(this.props.lookupId)
      .then((result) => {
        let optValues = [];
        let selected = [];
        result.forEach((lookupItem) => {
          const value = this.props.textAsValue ? lookupItem.text : lookupItem.value;
          const newValue = { label: lookupItem.text, value: value };
          optValues.push(newValue);
          if (
            this.props.selected &&
            (this.props.selected.includes(value) || this.props.selected.includes(parseInt(value)))
          ) {
            selected.push(newValue);
          }
        });
        this.setState({
          itemList: optValues,
          loading: false,
          selected: selected,
        });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('LMC57');
      });
  }

  multiSelectOnChange(selected) {
    this.setState({ selected: selected });
    this.props.onChange(selected);
  }

  renderList() {
    return (
      <MultiChoice
        label=''
        p-multiselect-panel={true}
        className='rmsc'
        options={this.state.itemList}
        selected={this.props.selected}
        onChange={this.multiSelectOnChange}
        labelledBy='Select'
      />
    );
  }

  render() {
    return (
      <div className='w-100 text-center hover rounded arial'>
        {this.props.label && (
          <label
            className='m-0 p-0 defaultfontsize '
            htmlFor={'htmlidfor' + this.props.fieldName}
          >
            {this.props.label}
          </label>
        )}
        {this.state.loading ? (
          <LoadingIcon
            loading={true}
            className='h6'
          />
        ) : (
          this.renderList()
        )}
      </div>
    );
  }
}
